import React from "react";

/* change_external_dsp — cambio de DSP externo (solo campañas pendientes). */
export default function ExternalDspProposal({ payload, t }) {
  return (
    <div className="chatbot-proposal-body">
      <p className="chatbot-proposal-reason">{t("ChatbotProposalDsp")}</p>
      <span className="chatbot-proposal-new-value">{payload.external_dsp_name}</span>
    </div>
  );
}
